var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultilineChip',{attrs:{"close":_vm.closable},on:{"input":_vm.remove}},[_c('div',{staticClass:"filter-chip"},[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }